<template>
  <vs-button
      radius
      color="#deeaee"
      type="filled"
      size="small"
      icon-pack="mdi"
      icon="mdi-chevron-down"
      @click="goDown()"
  ></vs-button>
</template>

<script>
  export default {
    name: "DownButton",

    props: {
      opendiv: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      goDown() {
       console.log(this.opendiv)
        if(this.opendiv==false){
          this.opendiv=true
        }
        else if(this.opendiv==true){
          this.opendiv=false
        }
        
        
      }
    },
  }
</script>

<style scoped>
.vs-component.vs-button.vs-button-primary.vs-button-border.includeIcon.includeIconOnly.vs-radius.small{
  border-style: solid;
  border-width: 5px;
}

.vs-button-primary.vs-button-border:hover{
   border-style: solid;
  border-width: 5px;
}

.vs-button-primary.vs-button-flat:hover{
  border-style: solid;
  border-width: 5px;
}
</style>